import { render, staticRenderFns } from "./MyTemplateDetails.vue?vue&type=template&id=a6243700&scoped=true&"
import script from "./MyTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./MyTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyTemplateDetails.vue?vue&type=style&index=0&id=a6243700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6243700",
  null
  
)

export default component.exports